<label>
  <div class="input-wrapper {{ size }}" [ngClass]="{ checked: model, disabled: disabled, error: error }">
    <input class="input" type="checkbox" [name]="name" [ngModel]="model" (ngModelChange)="emitChange($event)">
  </div>
  <span class="input-caption" *ngIf="caption && caption.length > 0 && (!error || errorMsg.length === 0)"
    [ngClass]="{ disabled: disabled, 'input-error-caption': error }">
    {{ caption }}
  </span>
  <span class="input-error-caption" *ngIf="error && errorMsg.length > 0">{{ errorMsg }}</span>
</label>